export enum AuthTokenProvider {
  Supabase = 'supabase',
  WorkOS = 'workos',
}

export type AuthStateChangeEvent = 'INITIAL_SESSION' | 'SIGNED_IN' | 'SIGNED_OUT' | 'TOKEN_REFRESHED'

export interface NormalizedAuthUser {
  id: string | null
  providerUserId: string | null
  email: string
  name: string
  avatarUrl: string | null
  provider: AuthTokenProvider
}

export interface NormalizedAuthSession {
  provider: AuthTokenProvider
  accessToken: string
  refreshToken: string
  expiresAt: number | null
  user: NormalizedAuthUser
}

export type AuthStateChangeCallback = (event: AuthStateChangeEvent, session: NormalizedAuthSession | null) => void

export interface AuthStateChangeSubscription {
  unsubscribe: () => void
}
